import React from "react";
import ISOCertificationImg from "../../../Assets/ISO Certification/CertificationImg.png";

const ISOContent45001 = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 lg:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="mb-3">
                <span className="border-b-4 border-[#249742]"> ISO 450</span>
                01:2018 CERTIFICATION
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              ISO 45001:2018 specifies requirements for an occupational health
              and safety (OH&S) management system, and gives guidance for its
              use, to enable organizations to provide safe and healthy
              workplaces by preventing work-related injury and ill health, as
              well as by proactively improving its OH&S performance. ISO
              45001:2018 is applicable to any organization that wishes to
              establish, implement and maintain an OH&S management system to
              improve occupational health and safety, eliminate hazards and
              minimize OH&S risks (including system deficiencies), take
              advantage of OH&S opportunities, and address OH&S management
              system nonconformities associated with its activities.
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid grid-cols-1">
          <div className="py-0 sm:py-8">
            <img
              src={ISOCertificationImg}
              className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOContent45001;
